import { useEffect, useState } from "react";
import { isMobile as isMobileView } from "@wix/picasso-common";

export function useMobile() {
  const [isMobile, setIsMobile] = useState(isMobileView());

  useEffect(() => {
    if (typeof window === "undefined") return;

    const handleResize = () => {
      setIsMobile(isMobileView());
    };

    // Add event listener
    window.addEventListener("resize", handleResize);

    // Cleanup
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return isMobile;
}
